import React from "react"
import { Link } from "gatsby"
import * as Icon from "react-feather"

import MapImg from "../../images/map.png"
import Shape1 from "../../images/shape1.png"
import Shape2 from "../../images/shape2.svg"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <>
      <footer className="footer-area bg-f7fafd">
        <div className="container">
          <div className="row justify-content-center">

            {/* Logo & About */}
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <div className="logo">
                  <Link to="/">
                    <h2 style={{ margin: 0 }}>CodeMobx</h2>
                  </Link>
                </div>
                <p>
                  CodeMobx is a modern web and mobile development company
                  delivering scalable, secure, and high-performance digital
                  solutions for startups and enterprises.
                </p>
              </div>
            </div>

            {/* Company */}
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget pl-5">
                <h3>Company</h3>
                <ul className="list">
                  <li><Link to="/coming-soon">About Us</Link></li>
                  <li><Link to="/coming-soon">Services</Link></li>
                  <li><Link to="/coming-soon">Portfolio</Link></li>
                  <li><Link to="/coming-soon">Careers</Link></li>
                  <li><Link to="/coming-soon">Blog</Link></li>
                </ul>
              </div>
            </div>

            {/* Support */}
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <h3>Support</h3>
                <ul className="list">
                  <li><Link to="/coming-soon">FAQ</Link></li>
                  <li><Link to="/coming-soon">Privacy Policy</Link></li>
                  <li><Link to="/coming-soon">Terms & Conditions</Link></li>
                  <li><Link to="/coming-soon">Help Center</Link></li>
                  <li><Link to="/coming-soon">Contact</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <h3>Contact</h3>

                <ul className="footer-contact-info">
                  <li>
                    <Icon.MapPin />
                    India
                  </li>
                  <li>
                    <Icon.Mail />
                    Email: <a href="mailto:info@codemobx.com">info@codemobx.com</a>
                  </li>
                  <li>
                    <Icon.PhoneCall />
                    Phone: <a href="tel:+910000000000">+91 00000 00000</a>
                  </li>
                </ul>

                <ul className="social-links">
                  <li>
                    <a href="#" className="facebook">
                      <Icon.Facebook />
                    </a>
                  </li>
                  <li>
                    <a href="#" className="twitter">
                      <Icon.Twitter />
                    </a>
                  </li>
                  <li>
                    <a href="#" className="instagram">
                      <Icon.Instagram />
                    </a>
                  </li>
                  <li>
                    <a href="#" className="linkedin">
                      <Icon.Linkedin />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Copyright */}
            <div className="col-lg-12 col-md-12">
              <div className="copyright-area">
                <p>
                  © {currentYear} CodeMobx. All rights reserved.
                </p>
              </div>
            </div>

          </div>
        </div>

        <img src={MapImg} className="map" alt="map" />

        <div className="shape1">
          <img src={Shape1} alt="shape" />
        </div>
        <div className="shape8 rotateme">
          <img src={Shape2} alt="shape" />
        </div>
      </footer>
    </>
  )
}

export default Footer